// extracted by mini-css-extract-plugin
module.exports = {"input":"Search_input__2nO_E","form":"Search_form__3xx8O","searching":"Search_searching__3yPvb","button":"Search_button__2NArD"};